import utilityHelper from './helperUtil'
import { Storage } from '../configs'

const validateUtil={}

validateUtil.checkNull = function(value){
    if(value === undefined || value === "" || value === null)
    return true;
    else 
    return false
}

validateUtil.compareRequiredData = function (poNo,data){
    let config=Storage.getRequiredFieldConfigs();
    var listMess = new Object()

    var listItems = new Object();
    var tableName = ''
    
    Object.entries(data).forEach(([keyTable, valueTable]) => {

        let valueRows = [];
        tableName = keyTable;
        var irRuning=1;

        if (!validateUtil.checkNull(valueTable) && valueTable.length === undefined)
            valueRows.push(valueTable)
        else if(!validateUtil.checkNull(valueTable) && valueTable.length > 0 )
            valueRows = valueTable
        var listTableMess = new Object();
        var sum = 0;
        Object.entries(valueRows).forEach(([keyRow, valueRow]) => {
            let i = valueRow["i"];
            let a = valueRow["a"];
            let itemId = valueRow["item_no"];
            itemId =  valueRow["service_item_no"] !== undefined ? valueRow["service_item_no"] : itemId
            let docType = '';

            if(!validateUtil.checkNull(itemId) && validateUtil.checkNull(i))
            {
                let mat = valueRow["material"];
                mat = mat == undefined ? '' : mat;
                switch(a){
                    case 'A' : docType += 'PA'; break
                    case 'F' : docType += 'PC'; break
                    case null:
                    case ''  : docType += 'PS'; break
                    case 'J' : docType +=  mat.length>0 ? 'PJM' : 'PJN' ; break
                }
            }
            else if(!validateUtil.checkNull(itemId) && !validateUtil.checkNull(i))
            {
                let overall_limit = valueRow["overall_limit"];
                let limit = overall_limit !== undefined 
                            && overall_limit > 0 ? 'U' : 'P'
                switch(a){
                    case 'A' : docType += 'S'+limit+'A'; break
                    case 'F' : docType += 'S'+limit+'C'; break
                    case 'J' : docType += 'S'+limit+'J'; break
                }
                docType += poNo.substr(0, 3) === '322' || poNo.substr(0, 3) === '324' 
                ? '-G' : ''
            }

            if(docType.length>=2){
                if(poNo.substr(0, 1) === '3')
                    docType = 'P-'+docType;
                else if(poNo.substr(0, 1) === '4')
                    docType = 'C-'+docType;
            }

            if(!validateUtil.checkNull(itemId) && !validateUtil.checkNull(docType)){ //Case GR Item ,Service
                listItems[itemId]=docType
            }
            else if(validateUtil.checkNull(docType) && validateUtil.checkNull(itemId)){ //Case GR SL
                docType = '*'
            }
            else if(validateUtil.checkNull(docType) && !validateUtil.checkNull(itemId)){ //Case GR SL
                docType = listItems[itemId]
                itemId +=( " Line " + valueRow["service_line_no"] );
            }
            var listRowMess = new Object();
            Object.entries(valueRow).forEach(([keyColumn, valueColumn]) => {
                let columnName = keyColumn,columnValue = valueColumn;
                if(
                    config[tableName] !== undefined &&
                    config[tableName][docType] !== undefined &&
                    config[tableName][docType][columnName] !== undefined
                ){
                    if(validateUtil.checkNull(columnValue) /*|| true*/)
                    {
                        listRowMess[columnName]=config[tableName][docType][columnName];
                        sum++;
                    }
                    else if (keyColumn === "receive_qty" && columnValue == 0){
                        listRowMess[columnName]=config[tableName][docType][columnName];
                        sum++;
                    }
                }

            })
            if(Object.keys(listRowMess).length>0)
            {
                if(tableName =='T_IR_DETAIL'){
                    listTableMess[irRuning]=listRowMess;
                    irRuning++;
                }
                else
                    listTableMess[itemId!==undefined?itemId:-1]=listRowMess;
            }
        })
        if(Object.keys(listTableMess).length>0){
            listMess[tableName]=listTableMess
            //listMess[tableName]["sum"]=sum;
        }

    })

    var isP=false,isS=false
    if(data["T_GR_ITEM"] !== undefined &&data["T_GR_ITEM"].length>0)
        isP=true;
    if(data["T_GR_SERVICE"] !== undefined &&data["T_GR_SERVICE"].length>0)
        isS=true;
    
    if(listMess["T_GR_DETAIL"] !== undefined && listMess["T_GR_DETAIL"][-1] !== undefined )
    {
        if(isP && !isS){
            if(listMess["T_GR_DETAIL"][-1]["doc_text"] !== undefined)
                delete listMess["T_GR_DETAIL"][-1]["doc_text"]
            if(listMess["T_GR_DETAIL"][-1]["reference"] !== undefined)
                delete listMess["T_GR_DETAIL"][-1]["reference"]
        }
        if(!isP && isS){
            if(listMess["T_GR_DETAIL"][-1]["delivery_note"] !== undefined)
                delete listMess["T_GR_DETAIL"][-1]["delivery_note"]
            if(listMess["T_GR_DETAIL"][-1]["po_header_text"] !== undefined)
                delete listMess["T_GR_DETAIL"][-1]["po_header_text"]
        }
        if(!isP && !isS && data.T_GR_ITEM !== undefined && data.T_GR_SERVICE !== undefined){
            
            let countP = data.TEMP_GR_ITEM !== undefined ? data.TEMP_GR_ITEM:0;
            let countS = data.TEMP_GR_SERVICE !== undefined ? data.TEMP_GR_SERVICE:0;

            if(countS > 0 && countP === 0)
            {
                if(listMess["T_GR_DETAIL"][-1]["delivery_note"] !== undefined)
                    delete listMess["T_GR_DETAIL"][-1]["delivery_note"]
                if(listMess["T_GR_DETAIL"][-1]["po_header_text"] !== undefined)
                    delete listMess["T_GR_DETAIL"][-1]["po_header_text"]
            }
            if(countP > 0 && countS === 0)
            {
                if(listMess["T_GR_DETAIL"][-1]["doc_text"] !== undefined)
                    delete listMess["T_GR_DETAIL"][-1]["doc_text"]
                if(listMess["T_GR_DETAIL"][-1]["reference"] !== undefined)
                    delete listMess["T_GR_DETAIL"][-1]["reference"]
            }
            if(countS > 0 && countP === 0)
            {
                if(listMess["T_GR_DETAIL"][-1]["delivery_note"] !== undefined)
                    delete listMess["T_GR_DETAIL"][-1]["delivery_note"]
                if(listMess["T_GR_DETAIL"][-1]["po_header_text"] !== undefined)
                    delete listMess["T_GR_DETAIL"][-1]["po_header_text"]
            }
            if(countP > 0 && countS > 0)
            {
                if(listMess["T_GR_DETAIL"][-1]["delivery_note"] !== undefined)
                    delete listMess["T_GR_DETAIL"][-1]["delivery_note"]
                if(listMess["T_GR_DETAIL"][-1]["po_header_text"] !== undefined)
                    delete listMess["T_GR_DETAIL"][-1]["po_header_text"]
                if(listMess["T_GR_DETAIL"][-1]["doc_text"] !== undefined)
                    delete listMess["T_GR_DETAIL"][-1]["doc_text"]
                if(listMess["T_GR_DETAIL"][-1]["reference"] !== undefined)
                    delete listMess["T_GR_DETAIL"][-1]["reference"]
            }


        }
    }

    var newList=new Object();
    Object.entries(listMess).forEach(([keyTable, valueTable]) => {
        newList[keyTable]= [];
        Object.entries(valueTable).forEach(([keyRow, valueRow]) => {

            if(keyRow === "-1"){
                Object.entries(valueRow).forEach(([keyCol, valueCol]) => {
                    newList[keyTable].push("กรุณาระบุ "+valueCol);
                })
            }
            else if(keyTable==='T_IR_DETAIL'){
                Object.entries(valueRow).forEach(([keyCol, valueCol]) => {
                    var rowMsg  = Object.keys(listMess[keyTable]).length > 1 
                    ?"IR รายการที่ "+ keyRow + " : ":"";

                    newList[keyTable].push("กรุณาระบุ "+rowMsg+valueCol);
                })
            }
            else {
                var rowMsg  = "Item "+ keyRow + " : "
                Object.entries(valueRow).forEach(([keyCol, valueCol]) => {
                    rowMsg+=  valueCol + " , "
                })
                rowMsg=rowMsg.substr(0,rowMsg.length-2)
                newList[keyTable].push("กรุณาระบุ "+rowMsg);
            }
        })
        if(newList[keyTable].length === 0)
            delete newList[keyTable];
    })


    return newList
}

validateUtil.checkRequiredData = function (tabName,transaction) {
    let data = null
    let listMess = []
    let poNo = transaction.t_PO_DETAIL != undefined ? transaction.t_PO_DETAIL.po_contract_no :'';
    if(tabName === "GR"){
        data = {
            "T_GR_DETAIL":transaction.t_GR_DETAIL,
            "T_GR_ITEM":transaction.t_GR_ITEM.filter(f => f.checked == 1),
            "T_GR_ITEM_ACCOUNT_ASSIGNMENT":transaction.t_GR_ITEM_ACCOUNT_ASSIGNMENT.filter(f => f.checked == 1),
            "T_GR_SERVICE":transaction.t_GR_SERVICE.filter(f => f.checked == 1),
            "T_GR_SERVICE_LINE":transaction.t_GR_SERVICELINE.filter(f => f.checked == 1),
            "T_GR_SERVICELINE_ACCOUNT_ASSIGNMENT":transaction.t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.filter(f => f.checked == 1),
            "TEMP_GR_ITEM":transaction.t_GR_ITEM.length,
            "TEMP_GR_SERVICE":transaction.t_GR_SERVICE.length,
        }
    }
    else if(tabName === "IR"){
        data = {
            "T_IR_DETAIL":transaction.t_IR_DETAIL
        }
    }
    else if(tabName === "MR" || tabName === 'CMD' ){
        data = {
            "T_GR_DETAIL":transaction.t_GR_DETAIL,
            "T_GR_ITEM":transaction.t_GR_ITEM.filter(f => f.checked == 1),
            "T_GR_ITEM_ACCOUNT_ASSIGNMENT":transaction.t_GR_ITEM_ACCOUNT_ASSIGNMENT.filter(f => f.checked == 1),
            "T_GR_SERVICE":transaction.t_GR_SERVICE.filter(f => f.checked == 1),
            "T_GR_SERVICE_LINE":transaction.t_GR_SERVICELINE.filter(f => f.checked == 1),
            "T_GR_SERVICELINE_ACCOUNT_ASSIGNMENT":transaction.t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.filter(f => f.checked == 1),
            "T_IR_DETAIL":transaction.t_IR_DETAIL,
            "T_IR_ITEM":transaction.t_IR_DETAIL,
            "T_MR_DETAIL":transaction.t_IR_DETAIL,
            "TEMP_GR_ITEM":transaction.t_GR_ITEM.length,
            "TEMP_GR_SERVICE":transaction.t_GR_SERVICE.length,
        }

        
    }
    else if(tabName === "MO" || tabName === "MOA"){
        data = {
            //"T_GR_DETAIL":transaction.t_GR_DETAIL,
            //"T_GR_ITEM":transaction.t_GR_ITEM.filter(f => f.checked == 1),
            //"T_GR_ITEM_ACCOUNT_ASSIGNMENT":transaction.t_GR_ITEM_ACCOUNT_ASSIGNMENT.filter(f => f.checked == 1),
            //"T_GR_SERVICE":transaction.t_GR_SERVICE.filter(f => f.checked == 1),
            //"T_GR_SERVICE_LINE":transaction.t_GR_SERVICELINE.filter(f => f.checked == 1),
            //"T_GR_SERVICELINE_ACCOUNT_ASSIGNMENT":transaction.t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.filter(f => f.checked == 1),
            //"T_IR_DETAIL":transaction.t_IR_DETAIL,
            //"T_IR_ITEM":transaction.t_IR_DETAIL,
            "T_MR_DETAIL":transaction.t_IR_DETAIL,
            //"TEMP_GR_ITEM":transaction.t_GR_ITEM.length,
            //"TEMP_GR_SERVICE":transaction.t_GR_SERVICE.length,
        }

        
    }
    listMess=this.compareRequiredData(poNo,data)

    return listMess;
}

validateUtil.addListError = function(listError,titleMess,errorMassage){
    if(errorMassage !== null){

        let list = [];
        if(!listError.hasOwnProperty(titleMess)){
            listError[titleMess] = [];
        }
        list = listError[titleMess];

        let sp=errorMassage.error_message.split("<br/>")
        if(sp.length > 0){
            for(var i in sp){
                if(!this.checkNull(sp[i]))
                list.push(sp[i]);
            }
        }
        else{
            list.push(errorMassage.error_message)
        }

        listError[titleMess] = list
    }
}

validateUtil.checkReceiveQty = function (t_GR_ITEM, t_GR_SERVICE, t_GR_SERVICELINE, po_no) {
 
    let is_contract = utilityHelper.checkIsContract(po_no);

    let checkQty = false
    let msgError = ""

    t_GR_ITEM && t_GR_ITEM.map((item, index) => {
        if (item.checked == 1) {
            if (is_contract) {
                if (item.po_qty) {
                    let _po_qty = utilityHelper.parseFloat(item.po_qty)
                    let _receive_qty = utilityHelper.parseFloat(item.receive_qty)
                    if (_receive_qty <= 0) {
                        // checkQty = true
                        // if (msgError) {
                        //     msgError += "<br/>Item " + item.item_no + " : กรุณาระบุ Receive Qty มากกว่า 0.000"
                        // }
                        // else {
                        //     msgError += "Item " + item.item_no + " : กรุณาระบุ Receive Qty มากกว่า 0.000"
                        // }
                    }

                    if (_receive_qty > _po_qty) {
                        checkQty = true
                        if (msgError) {
                            msgError += "<br/>กรุณาตรวจสอบข้อมูล Item " + item.item_no + " : Receive Qty มากกว่า PO/Target Qty"
                        }
                        else {
                            msgError += "กรุณาตรวจสอบข้อมูล Item " + item.item_no + " : Receive Qty มากกว่า PO/Target Qty"
                        }
                    }
                   else if (item.contract_item_no != null) {

                        let result = t_GR_ITEM.filter(f => f.item_no == item.contract_item_no || f.contract_item_no == item.contract_item_no)
                        if (result) {
                            let _receive_qty_type_add = 0
                            result && result.map((i, index) => {
                                _receive_qty_type_add += utilityHelper.parseFloat(i.receive_qty)
                            })

                            if (_receive_qty_type_add > _po_qty) {
                                checkQty = true
                                if (msgError) {
                                    msgError += "<br/>กรุณาตรวจสอบข้อมูล Item " + item.item_no + " : ผลรวมของ Receive Qty. มากกว่า PO/Target Qty"
                                }
                                else {
                                    msgError += "กรุณาตรวจสอบข้อมูล Item " + item.item_no + " : ผลรวมของ Receive Qty. มากกว่า PO/Target Qty"
                                }
                            }
                        }
                    }

                }
                else if (!item.receive_qty || item.receive_qty == 0) {
                    // checkQty = true
                    // if (msgError) {
                    //     msgError += "<br/>Item " + item.item_no + " : กรุณาระบุ Receive Qty มากกว่า 0.000"
                    // }
                    // else {
                    //     msgError += "Item " + item.item_no + " : กรุณาระบุ Receive Qty มากกว่า 0.000"
                    // }
                }

            }
            else {
                if (item.remaining_qty) {
                    let _remaining_qty = utilityHelper.parseFloat(item.remaining_qty)
                    let _receive_qty = utilityHelper.parseFloat(item.receive_qty)
                    if (_receive_qty <= 0) {
                        //  checkQty = true
                        //  if (msgError) {
                        //      msgError += "<br/>Item " + item.item_no + " : กรุณาระบุ Receive Qty มากกว่า 0.000"
                        //  }
                        //  else {
                        //      msgError += "Item " + item.item_no + " : กรุณาระบุ Receive Qty มากกว่า 0.000"
                        //  }
                    }
                    if (_receive_qty > _remaining_qty) {
                        checkQty = true
                        if (msgError) {
                            msgError += "<br/>กรุณาตรวจสอบข้อมูล Item " + item.item_no + " : Receive Qty มากกว่า Remaining Qty"
                        }
                        else {
                            msgError += "กรุณาตรวจสอบข้อมูล Item " + item.item_no + " : Receive Qty มากกว่า Remaining Qty"
                        }
                    }
                }
                else if (!item.receive_qty || item.receive_qty == 0) {
                    // checkQty = true
                    // if (msgError) {
                    //     msgError += "<br/>Item " + item.item_no + " : กรุณาระบุ Receive Qty มากกว่า 0.000"
                    // }
                    // else {
                    //     msgError += "Item " + item.item_no + " : กรุณาระบุ Receive Qty มากกว่า 0.000"
                    // }
                }
                else{
                    if (!item.remaining_qty) {
                        checkQty = true
                        if (msgError) {
                            msgError += "<br/>กรุณาตรวจสอบข้อมูล Item " + item.item_no + " : เนื่องจาก Remaining Qty เท่ากับ 0"
                        }
                        else {
                            msgError += "กรุณาตรวจสอบข้อมูล Item " + item.item_no + " : เนื่องจาก Remaining Qty เท่ากับ 0"
                        }
                    }
                }
            }
        }
    })
    
    let itmService = t_GR_SERVICE && t_GR_SERVICE.filter(f => f.checked == 1)

    itmService && itmService.map((s, index) => {
        let itmLine = t_GR_SERVICELINE.filter(f => f.service_item_no === s.service_item_no)
        itmLine && itmLine.map((row, index) => {
            if (row.checked == 1) {
                if (row.remaining_qty && is_contract == false) {
                    let _remaining_qty = utilityHelper.parseFloat(row.remaining_qty)
                    let _receive_qty = utilityHelper.parseFloat(row.receive_qty)
                    if(_receive_qty <= 0){
                        // checkQty = true
                        // if(msgError){
                        //     msgError += "<br/>Item " + row.service_item_no + " : Line: " + row.service_line_no + " กรุณาระบุ Receive Qty มากกว่า 0.000"
                        // }
                        // else{
                        //     msgError +=  "Item " + row.service_item_no + " : Line: " + row.service_line_no + " กรุณาระบุ Receive Qty มากกว่า 0.000"
                        // }
                    }
                    if (_receive_qty > _remaining_qty) {
                        checkQty = true
                        if(msgError){
                            msgError += "<br/>กรุณาตรวจสอบข้อมูล Item " + row.service_item_no + " : Line: " + row.service_line_no + " Receive Qty มากกว่า Remaining Qty"
                        }
                        else{
                            msgError += "กรุณาตรวจสอบข้อมูล Item " + row.service_item_no + " : Line: " + row.service_line_no + " Receive Qty มากกว่า Remaining Qty"
                        }
                    }
                }
                else if( is_contract && row.qty === null && row.remaining_qty === null){

                }
                else if (!row.receive_qty || row.receive_qty == 0) { //ย้ายไปเช็คข้อมูลรวม
                    // checkQty = true
                    // if (msgError) {
                    //     msgError += "<br/>Item " + row.service_item_no + " : Line: " + row.service_line_no + " กรุณาระบุ Receive Qty มากกว่า 0.000"
                    // }
                    // else {
                    //     msgError += "Item " + row.service_item_no + " : Line: " + row.service_line_no + " กรุณาระบุ Receive Qty มากกว่า 0.000"
                    // }
                }
                else{
                    if(!row.remaining_qty && !s.overall_limit){
                        checkQty = true
                        if(msgError){
                            msgError += "<br/>กรุณาตรวจสอบข้อมูล Item " + row.service_item_no + " : Line: " + row.service_line_no + " เนื่องจาก Remaining Qty เท่ากับ 0.000"
                        }
                        else{
                            msgError += "กรุณาตรวจสอบข้อมูล Item " + row.service_item_no + " : Line: " + row.service_line_no + " เนื่องจาก Remaining Qty เท่ากับ 0.000"
                        }
                    }
                }
            }
        })
    })

    if(checkQty){
        return {error_message: msgError}
    }
    else 
    return null

}


validateUtil.checkTotalReceiveVal = function (t_GR_SERVICE, t_GR_SERVICELINE) {        

    let overAll = 0
    let overAllAct = 0
    let totalRec = 0

    let itmService = t_GR_SERVICE.filter(f => f.checked == 1)      

    itmService && itmService.map((m, index)=>{
        overAll += m.overall_limit
        overAllAct += (m.overall_limit - m.actual_value)
        let itmLine = t_GR_SERVICELINE.filter(f=>f.service_item_no === m.service_item_no)            
        itmLine && itmLine.map((itm, idx)=>{
            if(itm.checked){
                totalRec += (itm.receive_qty*itm.gross_price)
            }
        })            
    })
    
    if(overAll > 0 && (totalRec > overAllAct)){
        return {error_message: "Total Receive Value มากกว่า (Overall Limit - Actual Value) กรุณาตรวจสอบข้อมูล"}
    }
    return null
}

validateUtil.checkCommiteeWithApprover = function (t_MR_DETAIL, t_PO_COMMITTEE) {        

    let overAll = 0
    let overAllAct = 0
    let totalRec = 0

    let itmCommittee = t_PO_COMMITTEE.filter(f => f.code == t_MR_DETAIL.approver_code)      

    console.log("itmCommittee  ==> ",itmCommittee);
    // itmCommittee && itmService.map((m, index)=>{
    //     overAll += m.overall_limit
    //     overAllAct += (m.overall_limit - m.actual_value)
    //     let itmLine = t_GR_SERVICELINE.filter(f=>f.service_item_no === m.service_item_no)            
    //     itmLine && itmLine.map((itm, idx)=>{
    //         if(itm.checked){
    //             totalRec += (itm.receive_qty*itm.gross_price)
    //         }
    //     })            
    // })
    
    if(itmCommittee.length > 0 ){
        return {error_message: "ผู้อนุมัติ PO ต้องไม่เป็นหนึ่งในคณะกรรมการตรวจรับ กรุณาตรวจสอบข้อมูล"}
    }
    return null
}

validateUtil.checkGoodsRecipientVal = function (t_GR_ITEM) { 

    let checkgoods_recipient = true
    let gitm = t_GR_ITEM.filter(f => f.checked == 1)
    if (gitm) {
        gitm && gitm.map((itm, idx) => {
            if (itm.goods_recipient) {
                checkgoods_recipient = false
            }
        })
    }

    if(checkgoods_recipient && gitm.length > 0){
        return {error_message: "กรุณาระบุ Goods Recipient อย่างน้อย 1 รายการ"}
    }
    return null

}

validateUtil.checkDummyAssect = function (t_GR_ITEM, t_GR_SERVICE, t_GR_SERVICELINE, t_GR_ITEM_ACCOUNT_ASSIGNMENT, t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT) {

    let checkAsset = false
    let msgError = ""
 
    let gitm = t_GR_ITEM && t_GR_ITEM.filter(f => f.checked == 1)
    if (gitm) {
        gitm && gitm.map((itm, idx) => {
            let itemAcc = t_GR_ITEM_ACCOUNT_ASSIGNMENT && t_GR_ITEM_ACCOUNT_ASSIGNMENT.filter(f => f.item_no === itm.item_no)
            
            itemAcc && itemAcc.map((acc, idx) => {
                let str = acc.asset;
                let macth1 = str && str.match(/^88BA[0-9]{2}?$/);
                if (macth1) {
                    checkAsset = true
                    if (msgError) {
                        msgError += "<br/>กรุณาตรวจสอบข้อมูล Item " + itm.item_no + " Asset: " + acc.asset+ " ไม่ถูกต้อง"
                    }
                    else {
                        msgError += "กรุณาตรวจสอบข้อมูล Item " + itm.item_no + " Asset: " + acc.asset+ " ไม่ถูกต้อง"
                    }
                }
                else {
                    let macth2 = str && str.match(/^99BA[0-9]{2}?$/);
                    if (macth2) {
                        checkAsset = true
                        if (msgError) {
                            msgError += "<br/>กรุณาตรวจสอบข้อมูล Item " + itm.item_no + " Asset: " + acc.asset+ " ไม่ถูกต้อง"
                        }
                        else {
                            msgError += "กรุณาตรวจสอบข้อมูล Item " + itm.item_no + " Asset: " + acc.asset+ " ไม่ถูกต้อง"
                        }
                    }
                }
            })
        })
    }

    let sItem = t_GR_SERVICE && t_GR_SERVICE.filter(f => f.checked == 1)
    if (sItem) {
        sItem && sItem.map((s, sindex) => {
            let lineItem = t_GR_SERVICELINE && t_GR_SERVICELINE.filter(f => f.service_item_no == s.service_item_no && f.checked == 1)

            lineItem && lineItem.map((l, lindex) => {
                let accItem = t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT && t_GR_SERVICELINE_ACCOUNT_ASSIGNMENT.filter(f => f.service_line_no == l.service_line_no && f.item_no == l.service_item_no)
                accItem && accItem.map((a, lindex) => {

                    let str = a.asset;
                    let macth1 = str && str.match(/^88BA[0-9]{2}?$/);
                    if (macth1) {
                        checkAsset = true
                        if (msgError) {
                            msgError += "<br/>กรุณาตรวจสอบข้อมูล Item " + s.service_item_no + ": Line: " + l.service_line_no  + " Asset: " + a.asset+ " ไม่ถูกต้อง"
                        }
                        else {
                            msgError += "กรุณาตรวจสอบข้อมูล Item " + s.service_item_no + ": Line: " + l.service_line_no  + " Asset: " + a.asset+ " ไม่ถูกต้อง"
                        }
                    }
                    else{
                        let macth2 = str && str.match(/^99BA[0-9]{2}?$/);
                        if (macth2) {
                            checkAsset = true
                            if (msgError) {
                                msgError += "<br/>กรุณาตรวจสอบข้อมูล Item " + s.service_item_no + ": Line: " + l.service_line_no  + " Asset: " + a.asset+ " ไม่ถูกต้อง"
                            }
                            else {
                                msgError += "กรุณาตรวจสอบข้อมูล Item " + s.service_item_no + ": Line: " + l.service_line_no  + " Asset: " + a.asset+ " ไม่ถูกต้อง"
                            }
                        }
                    }
                })
            })

        })
    }

    if (checkAsset) {
        return { error_message: msgError }
    }
    else
        return null
}

validateUtil.checkSelectItem = function (t_GR_ITEM, t_GR_SERVICE, t_GR_SERVICELINE) { 
    
    const gitem = t_GR_ITEM.filter(i => (i.checked === 1 || i.checked === '1'))
    const gservice = t_GR_SERVICE.filter(i => (i.checked === 1 || i.checked === '1'))
    
    if (gitem.length === 0 && gservice.length === 0) {
        return { error_message: " กรุณาเลือกรายการ ที่ต้องการรับ" }
    }
    else if (gservice.length > 0) {
        let listError = "";
        t_GR_SERVICE.map((m, index)=>{
            if(m.checked === '1' || m.checked === 1){
                let count = t_GR_SERVICELINE.filter(i => (i.checked === 1 || i.checked === '1' || i.checked === true) && i.service_item_no === m.service_item_no).length
                
                if(count === 0)
                {
                    if (listError) {
                        listError += "<br/>กรุณาตรวจสอบข้อมูล Item :" + m.service_item_no +" กรุณาเลือกรายการ Service Line ที่ต้องการรับ"
                    }
                    else {
                        listError += "กรุณาตรวจสอบข้อมูล Item :" + m.service_item_no +" กรุณาเลือกรายการ Service Line ที่ต้องการรับ"
                    }
                }

            }
        })
        if(listError !== "")
        return { error_message: listError }
    }
    return null

}

validateUtil.checkMultipleAccountAssignment = function (t_PO_DETAIL,t_GR_ITEM, t_GR_ITEM_ACCOUNT_ASSIGNMENT, po_no) {

    let is_contract = utilityHelper.checkIsContract(po_no);

    if (is_contract)
        return null;

    let msgError = ""
    const numeral = require('numeral');
    let isCheckPo = true
    if(t_PO_DETAIL.po_contract_no.substr(0,2) === "41" || t_PO_DETAIL.po_contract_no.substr(0,3) === "322" || t_PO_DETAIL.po_contract_no.substr(0,3) === "324"){
        isCheckPo = true
    }
    else
        isCheckPo = false

    isCheckPo && t_GR_ITEM && t_GR_ITEM_ACCOUNT_ASSIGNMENT && t_GR_ITEM.map((item, index) => {
        if (item.checked === 1 || item.checked === "1") {
            let count = t_GR_ITEM_ACCOUNT_ASSIGNMENT.filter(f => f.item_no === item.item_no).length;
            let qty = 0;
            let perce = 0;

            count > 0 && t_GR_ITEM_ACCOUNT_ASSIGNMENT
                && t_GR_ITEM_ACCOUNT_ASSIGNMENT.filter(f => f.item_no === item.item_no).map((acc, index) => {
                    qty += utilityHelper.parseFloat(numeral(acc.quantity).format('0,0.00'));
                    perce += utilityHelper.parseFloat(numeral(acc.perce).format('0,0.00'));
                })
            if (utilityHelper.parseFloat(numeral(item.receive_qty).format('0,0.00')) !== qty && item.distribution == "1") {
                if (msgError) {
                    msgError += "<br/>กรุณาตรวจสอบข้อมูล Item :" + item.item_no +" ผลรวม Quantity  มีค่าไม่เท่ากับ Receive Qty"
                }
                else {
                    msgError += "กรุณาตรวจสอบข้อมูล Item :" + item.item_no +" ผลรวม Quantity มีค่าไม่เท่ากับ Receive Qty"
                }
            }
            if (utilityHelper.parseFloat(numeral(perce).format('0,0.00')) !== 100 && item.distribution == "2") {
                if (msgError) {
                    msgError += "<br/>กรุณาตรวจสอบข้อมูล Item :" + item.item_no +"ผลรวม Perce มีค่าไม่เท่ากับ 100"
                }
                else {
                    msgError += "กรุณาตรวจสอบข้อมูล Item :" + item.item_no +" ผลรวม Perce มีค่าไม่เท่ากับ 100"
                }
            }
        }
    })

    if (msgError !== "") {
        return { error_message: msgError }
    }
    else
        return null

}


export default validateUtil